<template>
  <nav class="x-header navbar navbar-expand -logged py-0 back-to-top-btn">
    <div class="container-fluid align-items-center h-100 position-relative">
      <div id="headerBrand">
        <!-- <a class="btn navbar-brand" style="cursor: pointer; width: 20px; color: rgba(95, 117, 223, 0) !important;">
          <div role="button" class="menu_icon" style="top: -25px; left: -15px;"><span class="one"></span><span
              class="two"></span><span class="three"></span></div>
        </a> -->
        <div @click="goToHome()" class="-branding-inner-wrapper"><a class="navbar-brand" role="button"><img
              src="/static/img/logo/logo.png" class="w-logo-web" alt=""></a></div>
      </div>
      <div id="headerContent">
        <ul class="nav -menu-wrapper -logged">
          <!---->
          <!---->
          <!---->
          <!---->
        </ul>
        <div class="navbar-nav">
          <div class="x-logged">
            <!---->
            <!---->
            <div class="-profile-container">
              <!---->
              <div>
                <div class="d-flex">
                  <div class="flex-fill">
                    <!----><span @click="gotoRoute('/login')"
                      class="login-auth p-2 pl-2-1 v-login"><b>เข้าสู่ระบบ</b></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",

  data() {
    return {
      isShowNav: true,
      toggle: true,
      nowPage: this.$route.name,
      phoneNumber: "",
      password: "",
    };
  },
  watch: {
    $route() {
      this.isShowNav = true;
      this.nowPage = this.$route.name;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "userSignIn", "appTitle"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => { });
    },
    goToHome() {
      window.location = '/'

    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoRouteMobile(route) {
      var myCollapse = document.getElementById("navbarSupportedContent");
      console.log(myCollapse.classList.contains("show"));
      if (myCollapse.classList.contains("show")) {
        var bsCollapse = new bootstrap.Collapse(myCollapse);
        bsCollapse.hide();
      }
      this.$router.push(route).catch(() => { });
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => { });
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
    goToLine() {
      window.open(`https://line.me/R/ti/p/${this.getLineId}`, "_blank");
    },
    goToHome() {
      window.location = '/'

    },
  },
  computed: {
    ...mapGetters(["getLineId"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue